import clsx from 'clsx'
import './album-art.scss'
import { useState } from 'react'
import MediaLibrary from '../MediaLibrary/MediaLibrary'

const AlbumArt = ({
  value,
  onChange,
  label = 'Album Art',
  showRemove = false,
}) => {
  const [mediaLibraryOpen, setMediaLibraryOpen] = useState(false)
  const src =
    typeof value === 'string' || !value ? value : URL.createObjectURL(value)

  function handleMediaLibrarySubmit(image) {
    setMediaLibraryOpen(false)
    onChange(image.url)
  }
  return (
    <div className="album-art">
      {src && <img src={src} />}
      <div className={clsx('placeholder', { empty: !src })}>
        <h3>{label}</h3>
        <button
          className="button bg-blue mt-4 button-sm"
          onClick={() => setMediaLibraryOpen(true)}
        >
          Choose
        </button>
        {src && (
          <button
            className="button bg-blue mt-4 button-sm"
            onClick={() => onChange('')}
          >
            Remove
          </button>
        )}
      </div>
      <MediaLibrary
        isOpen={mediaLibraryOpen}
        onCancel={() => setMediaLibraryOpen(false)}
        onSubmit={handleMediaLibrarySubmit}
        type="albumArt"
      />
    </div>
  )
}

export default AlbumArt
